import { autoserialize } from 'cerialize';

export class Attachment {
  @autoserialize filename!: string;
  @autoserialize path!: string;
  @autoserialize rate!: number;
  @autoserialize polygon!: Array<[number, number]>;
  polygonHexColor!: string;
}
